import React from 'react'
import Paper from '@material-ui/core/Paper'
import { makeStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import TextField from '@material-ui/core/TextField'
import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import Button from '@material-ui/core/Button'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: '30px',
  },
  heading: {
    fontWeight: 'bold',
    fontSize: '2rem',
    marginBottom: theme.spacing(2),
  },
  formControl: {
    minWidth: 200,
    width: '100%',
  },
  button: {
    marginTop: theme.spacing(2),
  },
  tablePaper: {
    marginTop: theme.spacing(4),
    padding: theme.spacing(2),
  },
}))

// Datos mock para tabla
const mockData = [
  { potrero: 'Potrero 1', mes: '2023-01', manejo: 'Manejo 1', aplicacion: 'Aplicado' },
  { potrero: 'Potrero 2', mes: '2023-02', manejo: 'Manejo 2', aplicacion: 'No aplicado' },
]

export default function AnalyticsGrazingHistory() {
  const classes = useStyles()
  const [potrero, setPotrero] = React.useState('')
  const [manejo, setManejo] = React.useState('')
  const [startMonth, setStartMonth] = React.useState('')
  const [endMonth, setEndMonth] = React.useState('')
  const [filteredData, setFilteredData] = React.useState([])

  const handleFilter = () => {
    // Aquí podrías aplicar la lógica de filtrado real
    setFilteredData(mockData)
  }

  return (
    <div>
      <Paper className={classes.root}>
        <Typography className={classes.heading}>
          Historial de potreros
        </Typography>
        <Grid container spacing={3}>
          {/* Selector de mes DESDE */}
          <Grid item xs={12} sm={4} md={3}>
            <TextField
              label="Desde"
              type="month"
              value={startMonth}
              onChange={(e) => setStartMonth(e.target.value)}
              fullWidth
              InputLabelProps={{ shrink: true }}
              variant="outlined"
            />
          </Grid>

          {/* Selector de mes HASTA */}
          <Grid item xs={12} sm={4} md={3}>
            <TextField
              label="Hasta"
              type="month"
              value={endMonth}
              onChange={(e) => setEndMonth(e.target.value)}
              fullWidth
              InputLabelProps={{ shrink: true }}
              variant="outlined"
            />
          </Grid>

          {/* Selector de potreros */}
          <Grid item xs={12} sm={4} md={3}>
            <FormControl variant="outlined" className={classes.formControl}>
              <InputLabel>Potrero</InputLabel>
              <Select
                value={potrero}
                onChange={(e) => setPotrero(e.target.value)}
                label="Potrero"
              >
                <MenuItem value=""><em>Selecciona</em></MenuItem>
                <MenuItem value="Potrero 1">Potrero 1</MenuItem>
                <MenuItem value="Potrero 2">Potrero 2</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          {/* Selector de manejo */}
          <Grid item xs={12} sm={4} md={3}>
            <FormControl variant="outlined" className={classes.formControl}>
              <InputLabel>Manejo</InputLabel>
              <Select
                value={manejo}
                onChange={(e) => setManejo(e.target.value)}
                label="Manejo"
              >
                <MenuItem value=""><em>Selecciona</em></MenuItem>
                <MenuItem value="Manejo 1">Manejo 1</MenuItem>
                <MenuItem value="Manejo 2">Manejo 2</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>

        {/* Botón Aplicar filtros */}
        <Button
          variant="contained"
          color="primary"
          onClick={handleFilter}
          className={classes.button}
        >
          Aplicar filtros
        </Button>
      </Paper>

      {/* Tabla de resultados */}
      <Paper className={classes.tablePaper}>
        <Typography variant="h6" gutterBottom>
          Resultados filtrados
        </Typography>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Potrero</TableCell>
                <TableCell>Mes</TableCell>
                <TableCell>Manejo</TableCell>
                <TableCell>Insumo</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredData.map((row, index) => (
                <TableRow key={index}>
                  <TableCell>{row.potrero}</TableCell>
                  <TableCell>{row.mes}</TableCell>
                  <TableCell>{row.manejo}</TableCell>
                  <TableCell>{row.aplicacion}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </div>
  )
}
